<script setup>
import { inject } from "vue";

const bulk_upload_response = inject("bulk_upload_response");
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">MISSING DATA</h3>
            </div>
            <div class="card-body" x-data="filter-options">
              <div class="row">
                <label
                  v-if="bulk_upload_response.missingData?.length !== 0"
                  style="color: red"
                >
                  {{ bulk_upload_response.missingData?.length }}
                  device{{
                    bulk_upload_response.missingData?.length === 1 ? "" : "s"
                  }}
                  with missing info.
                </label>
                <table
                  v-if="bulk_upload_response.missingData?.length !== 0"
                  class="table table-striped"
                >
                  <thead>
                    <tr>
                      <th>ROW NO.</th>
                      <th>IMEI</th>
                      <th>ICCID</th>
                      <th>MSISDN</th>
                      <th>Device Class</th>
                      <th>Device Type</th>
                      <th>Provider</th>
                      <th>Missing Info</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="missing in bulk_upload_response.missingData"
                      :key="missing.row"
                    >
                      <td>{{ missing.row }}</td>
                      <td>{{ missing.imei || "" }}</td>
                      <td>{{ missing.iccid }}</td>
                      <td>{{ missing.msisdn }}</td>
                      <td>{{ missing.device_class }}</td>
                      <td>{{ missing.device_type }}</td>
                      <td>{{ missing.provider }}</td>
                      <td style="color: red">
                        {{ missing.missing_info?.replace(/,$/, "") }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div v-else style="color: green; font-weight: bold">
                  No Missing Data
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>
